import { DAY_PERIOD, THIRTY_DAY_RANGE } from 'constants/filters';
import { USERS_ENTITY, USERS_TYPE } from 'constants/analytics';
import { AnalyticsDataCtx } from './types';
import { format, sub } from 'date-fns';
import { UNSORTED } from 'types/sorting';

export const initalChartValues = {
  loading: false,
  count: null,
  finished: null,
  passed: null,
  error: false,
  items: null,
};

const initialEntitiesTableValues = {
  items: null,
  pageSize: 9,
  page: 1,
  loading: false,
  count: 0,
  error: false,
  currentEntity: USERS_ENTITY.VALUE,
  unavailable: false,
};

const initialCounterValue = {
  finished: null,
  passed: null,
  overall: null,
  started: null,
  watched: null,
  error: false,
  loading: false,
};

const initialActivitiesCounterValue = {
  ...initialCounterValue,
  labs: null,
  quizzes: null,
  videos: null,
};
const initialActiveUsersCounterValue = {
  total: null,
  licensed: null,
  withActivity: null,
};

// DEFAULT FILTERS DATES FOR ANALYTICS - 30 DAYS RANGE - DAY_PERIOD.VALUE
export const defaultAnalyticsRange = THIRTY_DAY_RANGE;
const defautlAnalyticsPeriod = DAY_PERIOD.VALUE;
const dateTo = new Date();
const dateFrom = sub(dateTo, {
  [defaultAnalyticsRange.PERIOD]: defaultAnalyticsRange.VALUE,
});

export const analyticsInitialValues: AnalyticsDataCtx = {
  error: null,
  fetching: false,
  fetchingCounters: false,
  fetchingTabCounters: false,
  filters: {
    date_to: format(dateTo, 'yyyy-LL-dd'),
    date_from: format(dateFrom, 'yyyy-LL-dd'),
    team_ids: null,
    period: defautlAnalyticsPeriod,
  },
  tableOrdering: UNSORTED,
  activities: initialActivitiesCounterValue,
  activeUsers: initalChartValues,
  entitiesTable: initialEntitiesTableValues,
  currentChart: USERS_TYPE.VALUE.toLowerCase(),
  counters: {
    users: initialActiveUsersCounterValue,
    activities: initialCounterValue,
    videos: initialCounterValue,
    videos_overall: initialCounterValue,
    slides: initialCounterValue,
    labs: initialCounterValue,
    quizzes: initialCounterValue,
  },
};
